import { gql } from '@apollo/client';

export const FR_EQUIPMENT_TYPE_FIELDS = gql`
    fragment fr_EquipmentTypeFields on EquipmentType {
        EquipmentTypeId
        Name
        Created
        Updated
    }
`;

export const FR_INSPECTION_LIST_EQUIPMENT_FIELDS = gql`
    fragment fr_InspectionListEquipmentFields on Equipment {
        EquipmentId
        Name
        Model
        SerialNbr
        Organization {
            OrganizationId
            Name
        }
        EquipmentType {
            ...fr_EquipmentTypeFields
        }
        Asset {
            AssetName
            AssetType
        }
    }
    ${FR_EQUIPMENT_TYPE_FIELDS}
`;

export const FR_EQUIPMENT_CLASS_TYPE_FIELDS = gql`
    fragment fr_EquipmentClassTypeFields on EquipmentClass {
        EquipmentClassId
        Name
        Created
        Updated
    }
`;

export const FR_EQUIPMENT_FIELDS = gql`
    fragment fr_EquipmentFields on Equipment {
        EquipmentId
        Name
        Model
        SerialNbr
        PurchaseDate
        PurchaseVendor
        InServiceDate
        IssueCount
        Updated
        Access {
            Read
            Create
            Delete
            Update
        }
        Organization {
            OrganizationId
            Name
        }
        EquipmentClass {
            ...fr_EquipmentClassTypeFields
        }
        EquipmentType {
            ...fr_EquipmentTypeFields
        }
        Asset {
            AssetName
            AssetType
        }
    }
    ${FR_EQUIPMENT_TYPE_FIELDS}
    ${FR_EQUIPMENT_CLASS_TYPE_FIELDS}
`;

export const FR_EQUIPMENT_LIST_FIELDS = gql`
    fragment fr_EquipmentListFields on Equipment {
        EquipmentId
        Name
        Model
        SerialNbr
        PurchaseDate
        InServiceDate
        IssueCount
        Updated
        Organization {
            OrganizationId
            Name
        }
        EquipmentClass {
            ...fr_EquipmentClassTypeFields
        }
        EquipmentType {
            ...fr_EquipmentTypeFields
        }
        Asset {
            AssetName
            AssetType
        }
    }
    ${FR_EQUIPMENT_TYPE_FIELDS}
    ${FR_EQUIPMENT_CLASS_TYPE_FIELDS}
`;
